/*
    Checks to see if 
*/
const isObjectLiteral = function (a: any) {
    return (!!a) && (a.constructor === Object);
};

export default isObjectLiteral;